module.exports = __webpack_public_path__ + "img/20200602.1a7414b4.png";